import { Component, OnInit,ChangeDetectorRef, HostListener } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api/public_api';
@Component({
  selector: 'bart-serv-req-main',
  templateUrl: './serv-req-main.component.html',
  styleUrls: ['./serv-req-main.component.scss']
})
export class ServReqMainComponent implements OnInit {
  scrHeight:any;
  scrWidth:any;

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
        this.scrHeight = (window.innerHeight)-200;
        this.scrWidth = window.innerWidth;
  }
  carsLarge = [];
    
  totalRecords: number;
  carsCaounter: number
  
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  
  ngOnInit() {
    this.totalRecords = 83;
    this.carsCaounter = 8;
    this.carsLarge = [];

  }
  
  loadCarsLazy(event: LazyLoadEvent) {
        setTimeout(() => {
            console.log("lazy")
            console.log(event);
            let tempCars = []
            for (let i = event.first; i < event.first+11; i++) {
              tempCars.push({"brand": "a", "year": i, "color": "Orange", "vin": "dsad231ff"})
              this.carsCaounter += 1;
            }
            this.carsLarge = tempCars;
            this.changeDetectorRef.detectChanges();
        }, 25);
  }

}
